import React from "react";

interface HighlightedHeadingProps {
  text: string;
  positions: number[]; // zero-based indexes of words to highlight
}

const HighlightedHeading: React.FC<HighlightedHeadingProps> = ({
  text,
  positions,
}) => {
  if (!text) return null;

  const words = text.split(" ");

  return (
    <h2 className="text-3xl lg:text-3xl font-rubik leading-tight  flex flex-wrap">
      {words.map((word, i) => {
        const isHighlighted = positions.includes(i);
        return (
          <span
            key={i}
            className={isHighlighted ? "text-gray-900 font-bold" : "text-gray-700 font-normal"}
            style={{ marginRight: "0.25rem" }}
          >
            {word}
          </span>
        );
      })}
    </h2>
  );
};

export default HighlightedHeading;
